import { useMutation } from '@tanstack/react-query';
import { api } from '../services/api';

/**
 * Mutation to regenerate a post
 * @param {function} onSuccess - Callback when post regeneration succeeds
 * @param {function} onError - Callback when post regeneration fails
 */
export const useRegeneratePost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, userInput }) => {
      const result = await api.regeneratePost(postId, userInput);
      return result;
    },
    onSuccess,
    onError,
  });
};

// Update post mutation: wraps api.updatePost and allows external success/error callbacks
export const useUpdatePost = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ postId, data }) => {
      return api.updatePost(postId, data);
    },
    onSuccess,
    onError,
  });
};

export const useSendFeedback = (onSuccess, onError) => {
  return useMutation({
    mutationFn: async ({ message, post_id }) => {
      return api.sendFeedback(message, post_id);
    },
    onSuccess,
    onError,
  });
};
